import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import '../components/AdminLayout.css';

function fmtDate(d) { return d ? new Date(d).toLocaleString('tr-TR') : '-'; }

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterRead, setFilterRead] = useState('');
  const [selectedNotif, setSelectedNotif] = useState(null);

  useEffect(() => { fetchNotifications(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchNotifications() {
    setLoading(true);
    try {
      const { data: rawNotifs, error } = await supabase
        .from('notifications')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) { console.error('Notifications error:', error); setLoading(false); return; }

      const userIds = [...new Set((rawNotifs || []).map(n => n.user_id).filter(Boolean))];
      let profileMap = {};
      if (userIds.length > 0) {
        const { data: profiles } = await supabase.from('profiles').select('id, name, email').in('id', userIds);
        if (profiles) profiles.forEach(p => { profileMap[p.id] = p; });
      }

      let enriched = (rawNotifs || []).map(n => ({ ...n, user: profileMap[n.user_id] || null }));

      if (filterType) enriched = enriched.filter(n => n.type === filterType);
      if (filterRead === 'read') enriched = enriched.filter(n => n.is_read);
      if (filterRead === 'unread') enriched = enriched.filter(n => !n.is_read);
      if (search) enriched = enriched.filter(n => (n.title || '').toLowerCase().includes(search.toLowerCase()));

      setNotifications(enriched);
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  return (
    <div>
      <div className="admin-filter-bar">
        <input className="admin-search-input" placeholder="Başlık ile ara..." value={search} onChange={e => setSearch(e.target.value)} />
        <select className="admin-select" value={filterType} onChange={e => setFilterType(e.target.value)}>
          <option value="">Tüm Tipler</option>
          <option value="match">Eşleşme</option>
          <option value="note_approval">Not Onayı</option>
          <option value="message">Mesaj</option>
          <option value="system">Sistem</option>
        </select>
        <select className="admin-select" value={filterRead} onChange={e => setFilterRead(e.target.value)}>
          <option value="">Tüm Durumlar</option>
          <option value="read">Okundu</option>
          <option value="unread">Okunmadı</option>
        </select>
        <button className="btn-admin btn-admin-primary" onClick={fetchNotifications}>Filtrele</button>
      </div>

      <div className="admin-table-wrapper">
        <div className="admin-table-scroll">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Başlık</th>
                <th>Tip</th>
                <th>Kullanıcı</th>
                <th>Eşleşme ID</th>
                <th>Okundu</th>
                <th>Tarih</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr className="admin-loading-row"><td colSpan={6}>Yükleniyor...</td></tr>
              ) : notifications.length === 0 ? (
                <tr className="admin-loading-row"><td colSpan={6}>Bildirim bulunamadı.</td></tr>
              ) : notifications.map(n => (
                <tr key={n.id}>
                  <td>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#5784E6', fontWeight: 600, padding: 0, fontSize: '0.875rem', fontFamily: 'inherit' }} onClick={() => setSelectedNotif(n)}>
                      {n.title || '-'}
                    </button>
                  </td>
                  <td><span className="badge badge-purple">{n.type || '-'}</span></td>
                  <td>{n.user?.name || '-'}</td>
                  <td style={{ fontSize: '0.75rem', color: '#7A8BAD' }}>{n.match_id ? String(n.match_id).slice(0, 8) + '...' : '-'}</td>
                  <td>{n.is_read ? <span className="badge badge-green">Okundu</span> : <span className="badge badge-orange">Okunmadı</span>}</td>
                  <td>{fmtDate(n.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="admin-table-footer">Toplam {notifications.length} bildirim gösteriliyor</div>
      </div>

      {selectedNotif && (
        <div className="admin-drawer-overlay" onClick={() => setSelectedNotif(null)}>
          <div className="admin-drawer" onClick={e => e.stopPropagation()}>
            <div className="admin-drawer-header">
              <h3>Bildirim Detayı</h3>
              <button className="admin-drawer-close" onClick={() => setSelectedNotif(null)}>✕</button>
            </div>
            <div className="admin-drawer-body">
              <div className="detail-row"><label>Başlık</label><span>{selectedNotif.title || '-'}</span></div>
              <div className="detail-row"><label>İçerik</label><span>{selectedNotif.body || selectedNotif.message || '-'}</span></div>
              <div className="detail-row"><label>Tip</label><span><span className="badge badge-purple">{selectedNotif.type || '-'}</span></span></div>
              <div className="detail-row"><label>Kullanıcı</label><span>{selectedNotif.user?.name || '-'}</span></div>
              <div className="detail-row"><label>E-posta</label><span>{selectedNotif.user?.email || '-'}</span></div>
              <div className="detail-row"><label>Eşleşme ID</label><span style={{ fontSize: '0.75rem', wordBreak: 'break-all' }}>{selectedNotif.match_id || '-'}</span></div>
              <div className="detail-row"><label>Okundu</label><span>{selectedNotif.is_read ? <span className="badge badge-green">Okundu</span> : <span className="badge badge-orange">Okunmadı</span>}</span></div>
              <div className="detail-row"><label>Tarih</label><span>{fmtDate(selectedNotif.created_at)}</span></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
